import Vue from 'vue'
import { Icon } from 'vant';
import App from './App.vue'
import router from './router'
import './assets/icons'
import './plugins'
import './assets/styles/index.less'

// if (process.env.NODE_ENV === 'development') {
//   // new VConsole()
// }
// if (process.env.NODE_ENV !== 'development') {
//   console.log(navigator.userAgent)
//   console.log(`last delopy: %c${process.env.NOW}`, 'color: #67C23A')
// }
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
router.beforeEach((to, from, next)=>{
  if(to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

Vue.use(Icon);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
